import _taggedTemplateLiteral from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import { jsxs as t, Fragment as e, jsx as r } from "react/jsx-runtime";
import { TextLink as n } from "@vds-core/buttons";
import { ListItem as i, UnorderedList as c } from "@vds-core/lists";
import { TrailingTooltip as s } from "@vds-core/tooltips";
import a, { attributesToProps as o, domToReact as p } from "html-react-parser";
import { Fragment as d } from "react";
import l from "styled-components";
var m = l.span.withConfig({
    displayName: "ScreenReaderText",
    componentId: "VDS__sc-192suox-0"
  })(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n"]))),
  h = {
    replace: function replace(a) {
      if (a && a.type && a.attribs && a.attribs.onclick && (a.attribs.onClick = new Function(a.attribs.onclick), delete a.attribs.onclick), "tag" !== a.type) {
        if ("text" === a.type && a.data.includes("\n")) {
          return a.data.split("\n").map(function (e, n, i) {
            return n === i.length - 1 ? e : t(d, {
              children: [e, r("br", {})]
            }, n);
          });
        }
        return !(a.next && "tip" === a.next.name) && a.data;
      }
      {
        var _d = o(a.attribs);
        switch (a.name) {
          case "a":
            return r(n, Object.assign({}, _d, {
              children: p(a.children, h)
            }));
          case "ul":
            return r(c, Object.assign({}, _d, {
              children: p(a.children, h)
            }));
          case "li":
            return r(i, Object.assign({}, _d, {
              children: p(a.children, h)
            }));
          case "sup":
            return t("sup", Object.assign({}, _d, {
              children: [r(m, {
                children: "superscript "
              }), p(a.children, h)]
            }));
          case "s":
            return r("s", Object.assign({}, _d, {
              children: p(a.children, h)
            }));
          case "tip":
            return t(e, {
              children: [r(s, {
                typographyPrimitive: "span",
                tooltipContent: p(a.children),
                children: a.prev && a.prev.data ? a.prev.data.trim() : ""
              }), " "]
            });
        }
      }
    }
  },
  u = function u(t) {
    return a(t, h);
  };
export { u as default };